/**
 * Shared utilities for file upload components
 * Ensures consistent file type handling across all upload components
 */

export const ACCEPTED_FILE_TYPES = {
  MIME_TYPES: [
    'text/csv',
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  ],
  EXTENSIONS: ['.csv', '.xlsx', '.xls'],
  EXTENSIONS_WITHOUT_DOT: ['csv', 'xlsx', 'xls'],
} as const;

export const FILE_TYPE_DISPLAY = {
  formats: 'CSV, XLSX, XLS',
  formatsShort: 'CSV/XLSX/XLS',
  errorMessage: 'Veuillez sélectionner un fichier CSV, XLSX ou XLS',
} as const;

/**
 * Validates if a file is of an accepted type
 */
export const isValidFileType = (file: File): boolean => {
  return (
    ACCEPTED_FILE_TYPES.MIME_TYPES.includes(file.type as any) ||
    ACCEPTED_FILE_TYPES.EXTENSIONS_WITHOUT_DOT.some(ext => 
      file.name.toLowerCase().endsWith(`.${ext}`)
    )
  );
};

/**
 * Gets the accept attribute value for file input elements
 */
export const getFileInputAccept = (): string => {
  return ACCEPTED_FILE_TYPES.EXTENSIONS.join(',');
};

/**
 * Gets formatted file type information for display in modals/UI
 */
export const getFileTypeInfo = () => ({
  formats: FILE_TYPE_DISPLAY.formats,
  formatsShort: FILE_TYPE_DISPLAY.formatsShort,
  errorMessage: FILE_TYPE_DISPLAY.errorMessage,
  acceptedExtensions: ACCEPTED_FILE_TYPES.EXTENSIONS_WITHOUT_DOT,
});

